import { useAuth, WithAuthorization } from "../../../context";
import { Card } from "../../../components/Card";
import { Button, Icon, useToast } from "@chakra-ui/react";
import { DataTable } from "../../../components/DataTable";
import { Page } from "../../../components/Page";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { routes } from "../../../config";
import { QUESTIONNAIRE_STATUSES, showErrorToast } from "../../../utils";
import { FaEye, FaPen } from "react-icons/fa";
import { useGetAllCSRDQuestionnaires } from "../../../hooks/query/csrd";
import { hideAppSpinner } from "../../../context/Store/slices/appSpinnerSlice";

function CSRDQuestionnaires() {
  const { t } = useTranslation("translation", {
    keyPrefix: "csrd"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const dispatch = useDispatch();
  const toast = useToast();
  const { user } = useAuth();
  const navigate = useNavigate();

  const columns = useMemo(() => {
      return [
        {
          header: t("gridHeaders.questionnaireType"),
          accessorKey: "type",
          size: 150
        },
        {
          header: t("gridHeaders.assignee"),
          accessorKey: "assigneeName",
          size: 200
        },
        {
          header: t("gridHeaders.year"),
          accessorKey: "year",
          size: 130
        },
        {
          header: t("gridHeaders.status"),
          accessorKey: "status",
          size: 150
        },
        {
          header: <div style={{ textAlign: "left" }}><b>{t("gridHeaders.actions")}</b></div>,
          accessorKey: "action",
          size: 100,
          cell: row => {
            const { row: { original: rowData } } = row;
            const tooltipAction =
              rowData.originalStatus === QUESTIONNAIRE_STATUSES.FINALIZED ?
                globalTranslation("buttons.review") : globalTranslation("buttons.edit");

            return <Button
              onClick={() => navigate(`${routes.csrdQuestionnaire}?id=${rowData.id}`)}
              variant="ghost"
              title={`${tooltipAction} ${t("questionnaires.csrd")} ${globalTranslation("questionnaire")}`}
            >
              <Icon
                as={rowData.originalStatus === QUESTIONNAIRE_STATUSES.FINALIZED ?
                  FaEye : FaPen
                }
                inlineSize="4"
                blockSize="4"
                color={"green"}
                opacity="0.7"
              />
            </Button>;
          }
        }
      ];
    }, [t, navigate, globalTranslation]
  );

  const mapData = (data) => {
    if (data && typeof data !== "undefined" && data.content?.length > 0) {
      return data.content.map(el => {
        return {
          id: el.id,
          type: t(`questionnaireTypes.${el?.type ?? ""}`, { defaultValue: "" }),
          originalType: el?.type,
          assigneeName: el?.assignee ?? "",
          assignee: el?.assignee ?? "",
          year: el?.year?.toString() ?? "",
          status: globalTranslation("questionnaireStatus." + el?.status),
          originalStatus: el?.status
        };
      });
    }
    return [];
  };

  const {
    data: allCSRDQuestionnaires,
    isFetching
  } = useGetAllCSRDQuestionnaires(`assigneeName=${user?.email}`,
    {
      onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
      onSettled: () => {
        dispatch(hideAppSpinner());
      },
      cacheTime: 0,
      enabled: user !== null && typeof user !== "undefined"
    }
  );

  return (
    <Page title={t("questionnaires.page.title")} subTitle={t("questionnaires.page.subTitle")}>
      <Card>
        <DataTable
          data={mapData(allCSRDQuestionnaires)}
          columns={columns}
          isLoading={isFetching}
          marginBlockEnd={4}
          containerHeight="var(--chakra-sizes-2xl)"
        />
      </Card>
    </Page>
  );
}

export default WithAuthorization(CSRDQuestionnaires);